<template>
  <div>
    <v-row
      no-gutters
      align="center"
      :class="ordine.nuovo ? 'font-weight-bold' : ''"
      class="pa-2"
    >
      <v-col cols="1" class="d-flex align-center text-truncate">
        <v-sheet
          :color="ordine.nuovo ? 'success' : 'white'"
          height="50"
          width="5"
          rounded
        ></v-sheet>
        <span class="mx-1"># {{ ordine.numero }}</span>
        <Dettaglio :ordine="ordine" :tot_cc="tot_cc"></Dettaglio>
        <v-btn
          v-if="ordine.subConteggio && ordine.subConteggio.length > 0"
          icon
          color="grey"
          class="mx-1"
          @click="show_sub = !show_sub"
        >
          <v-icon>mdi-subdirectory-arrow-right</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1">
        <v-row no-gutters>
          {{ ordine.data }}
        </v-row>
        <v-row no-gutters class="mt-n2">
          <span style="font-size: 10px" class="grey--text">{{
            ora_ordine
          }}</span>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12" class="text-truncate">
            {{ ordine.cliente }}
          </v-col>
          <v-col
            cols="12"
            class="purple--text mt-n1"
            style="font-size: 10px"
            v-if="ordine.crisantemi"
          >
            <v-icon size="8" color="purple">mdi-cross</v-icon> Ordine Santi
          </v-col>
          <v-col
            cols="12"
            class="green--text mt-n2"
            style="font-size: 10px"
            v-else-if="ordine.makeByAdmin"
          >
            Creato da Admin
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="1">
        <v-row no-gutters>
          <CambiaTipo :ordine="ordine" />
          <CambiaData :ordine="ordine" />
          <v-col
            cols="12"
            style="font-size: 10px"
            class="mt-n1"
            v-if="ordine.consegna_programmata"
          >
            <v-icon color="purple" size="15" class="">mdi-truck</v-icon>
            <span class="purple--text"> Pianificata</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1" class="d-flex justify-end pr-2"> € {{ totale }} </v-col>
      <v-col cols="1" class="d-flex justify-end pr-6">
        {{ tot_cc }}
      </v-col>
      <v-col cols="2">
        <v-row no-gutters>
          <v-col
            cols="12"
            @click="apri_modale()"
            :style="ordine.conteggiato ? 'cursor:pointer' : ''"
          >
            <v-icon :color="stato.color" class="mr-2">{{ stato.mdi }}</v-icon>
            <span :class="stato.color + '--text'">{{ stato.text }}</span>
            <v-icon
              v-if="ordine.contabilizzato"
              size="12"
              class="ml-2"
              :color="tipo_contabilizzato"
              >mdi-circle</v-icon
            >
          </v-col>
          <v-col cols="12" style="font-size: 10px">
            <template v-if="!ordine.visibile">
              <v-icon color="grey" size="15">mdi-eye-off</v-icon>
              Nascosto
            </template>

            <template v-if="ordine.is_joined">
              <v-icon color="amber" size="15" class="ml-2">mdi-merge</v-icon>
              <span class="amber--text"> Unito</span>
            </template>
          </v-col>
        </v-row>
        <DettaglioConteggio
          v-if="ordine.conteggiato"
          :conteggio="conteggio"
          :ordine="ordine"
          :loading="loading_conteggio"
          ref="modale_conteggio"
        />
      </v-col>
      <v-col cols="2" class="">
        <Dettaglio
          :ordine="ordine"
          :tot_cc="tot_cc"
          v-if="ordine.stato == 0"
        ></Dettaglio>
        <ArchiviaOrdine v-if="ordine.stato != 0" :id_ordine="ordine._id.$oid" />
        <template v-if="ordine.stato != 8 && ordine.stato != 0">
          <v-badge offset-x="15" offset-y="13" dot :value="ordine.stampata">
            <v-btn icon color="purple" class="mx-1" @click="print_pdf()">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </v-badge>
        </template>

        <v-btn
          v-if="ordine.stato == 8"
          icon
          color="green"
          class="mx-1"
          :loading="loading_invia_csv"
          @click="spedisci_conteggio"
        >
          <v-icon>mdi-send</v-icon>
        </v-btn>
        <v-menu v-model="menu_opzioni">
          <template v-slot:activator="{ on }">
            <v-btn icon class="mx-1" color="grey" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-dialog v-model="dialog_delete" width="600">
              <template v-slot:activator="{ on }">
                <v-list-item v-on="on">
                  <v-list-item-avatar>
                    <v-icon color="red"> mdi-delete </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title> Elimina </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-card>
                <v-card-title class="error--text"> Elimina </v-card-title>
                <v-card-text v-if="!in_consegna">
                  L'ordine verrà eliminato e non sarà piu recuperabile
                  <br />
                  Sei Sicuro?
                </v-card-text>
                <v-card-text v-else>
                  <v-list-item>
                    <v-list-item-avatar>
                      <v-icon color="amber">mdi-alert</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        L'ordine è collegato ad una consegna. Impossibile
                        eliminare.
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Consegna # {{ consegna_collegata.numero }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn text color="primary" @click="dialog_delete = false">
                    Annulla
                  </v-btn>
                  <v-btn
                    v-if="!in_consegna"
                    color="error"
                    :loading="loading_elimina"
                    @click="elimina_ordine()"
                  >
                    <v-icon class="ml-2">mdi-delete</v-icon>
                    Elimina
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-list-item @click="visibilità(!ordine.visibile)">
              <v-list-item-avatar>
                <v-icon color="blue">{{
                  ordine.visibile ? "mdi-eye" : "mdi-eye-off"
                }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{
                  ordine.visibile ? "Nascondi" : "Rivela"
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <UnisciOrdini
              v-if="ordine.stato == 1"
              :iva="ordine.iva"
              :id="ordine._id.$oid"
            />
            <RifOrdini
              v-if="ordine.is_joined"
              :lista_uniti="ordine.joined_from"
            />
            <v-list-item @click="apri_modale()" v-if="ordine.conteggiato">
              <v-list-item-avatar>
                <v-icon color="green">mdi-playlist-check</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title> Conteggio </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="toggle_letto()">
              <v-list-item-avatar>
                <v-icon>{{
                  !ordine.nuovo ? "mdi-email-outline" : "mdi-email-open-outline"
                }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ ordine.nuovo ? "Segna Letto" : "Segna Da Leggere" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-dialog v-model="error_contabile_collegata" width="600">
      <v-card>
        <v-card-title class="error--text"> Impossibile eliminare </v-card-title>
        <v-card-text>
          L'ordine è collegato ad una contabile. Impossibile eliminare.
          <br />
          Prima di eliminare l'ordine, elimina la contabile collegata.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="error_contabile_collegata = false"
          >
            Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row v-if="show_sub" align="center" no-gutters>
      <v-col
        v-for="sub in ordine.subConteggio"
        :key="sub.id.$oid"
        cols="12"
        class="d-flex align-center text-truncate"
      >
        <v-row no-gutters class="" align="center">
          <v-col cols="1" class="d-flex justify-end">
            <v-icon size="15" color="blue" class="mr-8"
              >mdi-subdirectory-arrow-right</v-icon
            >
          </v-col>
          <v-col cols="1" class="ml-1">
            <span class=""># {{ sub.subNumero }}</span>
          </v-col>
          <v-col cols="2" class="">
            Carrelli:
            <span
              v-for="(car, index) in sub.id_carrelli"
              :key="car.id_carrello"
            >
              <b>{{
                carrello({ id_conteggio: sub.id_conteggio, id_carrello: car })
                  .index + 1
              }}</b>
              <span v-if="index < sub.id_carrelli.length - 1" class="mx-1"
                >-</span
              >
            </span>
          </v-col>
          <v-col cols="1"> € {{ calcola_totale_sub(sub).toFixed(2) }}
          </v-col>
          <v-col cols="1">
            <span
              :class="stato_consegna(sub).color + '--text'"
              style="font-size: 10px"
              ><v-icon size="18" :color="stato_consegna(sub).color">{{
                stato_consegna(sub).mdi
              }}</v-icon>
              {{ stato_consegna(sub).text }}</span
            >
          </v-col>
          <v-col cols="2">
            <template v-if="!sub.contabilizzato">
              <v-btn
                v-if="!ordine.contabilizzato"
                class="my-1"
                outlined
                x-small
                color="purple"
                @click="open_nuova_contabile(sub)"
              >
                Crea Contabile</v-btn
              >
            </template>
            <span v-else class="teal--text" style="font-size: 12px"
              ><v-icon color="teal" size="18">mdi-cash</v-icon>
              Contabilizzato</span
            >
          </v-col>
        </v-row>
      </v-col>
      <!-- <NuovaContabile
        :cliente_prop="ordine.iva"
        :ordine_id_prop="ordine._id.$oid"
        :sub_conteggio_prop="sub_conteggio_selected"
        :totale_documento="calcola_totale_sub(sub_conteggio_selected)"
        ref="nuovaContabile"
        noButton
      /> -->
      <NuovaContabile
        :ordine_prop="ordine ? ordine.numero.toString() : ''"
        :ordine_id_prop="ordine ? ordine._id.$oid : ''"
        :sub_conteggio_prop="sub_conteggio_selected"
        :conteggio_prop="conteggio.id"
        :cliente_prop="ordine.iva"
        :totale_documento="calcola_totale_sub(sub_conteggio_selected)"
        :tot_iva_documento="calcola_iva_sub(sub_conteggio_selected)"
        :tot_trasporto_documento="tot_trasporto()"
        :tot_iva_trasporto_documento="tot_iva_trasporto()"
        ref="nuovaContabile"
        noButton
      />
    </v-row>
  </div>
</template>

<script>
import Dettaglio from "./ordine_dettaglio/ordine_dettaglio_dialog.vue";
import RifOrdini from "./ordine_riferimento_unito.vue";
import ArchiviaOrdine from "./ordine_attivo_utilità/menu_archivia_ordine.vue";

import UnisciOrdini from "./ordine_attivo_utilità/unisci_ordini_dialog.vue";
import CambiaData from "./ordine_attivo_utilità/cambia_data_ordine.vue";
import CambiaTipo from "./ordine_attivo_utilità/cambia_tipo_consegna.vue";
import ordine_attivo_mixin from "../mixin/ordine_attivo_element_mixin";

import DettaglioConteggio from "@/components/Conteggi/desktop/dettaglio_conteggio/conteggio_dettaglio";
import NuovaContabile from "../../Contabili/desktop/nuova_contabile.vue";
export default {
  components: {
    Dettaglio,
    UnisciOrdini,
    RifOrdini,
    CambiaData,
    CambiaTipo,
    DettaglioConteggio,
    ArchiviaOrdine,
    NuovaContabile,
  },
  mixins: [ordine_attivo_mixin],
  props: {
    ordine: Object,
  },
  data() {
    return {
      loading_conferma: false,
      loading_elimina: false,
      dialog_delete: false,
      menu_opzioni: false,
      sub_conteggio_selected: null,
      enable_nuova_contabile: false,
    };
  },
  computed: {
    ritiro() {
      switch (this.ordine.ritiro_cod) {
        case 1:
          return { text: "Consegna", color: "blue", cod: 1 };
        case 0:
          return { text: "Ritiro", color: "green", cod: 0 };
      }
      return { text: "err", color: "red" };
    },
  },
  methods: {
    carrello(payload) {
      return this.$store.getters.get_carrello_by_id(payload);
    },
    open_nuova_contabile(sub) {
      this.sub_conteggio_selected = sub;
      this.enable_nuova_contabile = true;
      setTimeout(() => {
        this.$refs.nuovaContabile.open();
      }, 100);
    },
    calcola_totale_sub(sub) {
      if (!this.ordine || !sub) return 0;
      let carrelli = this.conteggio.carrelli.filter((c) =>
        sub.id_carrelli.includes(c.id_carrello)
      );
      let prezzo = 0;
      carrelli.forEach((carrello) => {
        carrello.prodotti.forEach((p) => {
          const prodotto = this.conteggio.prodotti.find(
            (prod) => prod.id_prodotto === p.id_prodotto
          );
          if (prodotto && prodotto.prezzo_contato && p.qta) {
            prezzo += prodotto.prezzo_contato * p.qta;
          }
        });
      });
      return prezzo;
    },
    calcola_iva_sub(sub) {
      if (!this.ordine || !sub) return 0;
      let carrelli = this.conteggio.carrelli.filter((c) =>
        sub.id_carrelli.includes(c.id_carrello)
      );
      let iva = 0;
      carrelli.forEach((carrello) => {
        carrello.prodotti.forEach((p) => {
          const prodotto = this.conteggio.prodotti.find(
            (prod) => prod.id_prodotto === p.id_prodotto
          );
          if (prodotto && prodotto.prezzo_contato && p.qta) {
            let prodotto_raw = this.$store.getters.get_prodotto_by_id(
              p.id_prodotto
            );
            iva += (prodotto.prezzo_contato * p.qta * prodotto_raw.iva) / 100;
          }
        });
      });
      return iva;
    },
    tot_trasporto(){
      if (this.ordine && this.ordine.tot_trasp) {
        return this.ordine.tot_trasp;
      } else {
        return 0;
      }
    },
    tot_iva_trasporto() {
      if (this.ordine && this.ordine.tot_trasp) {
        return this.ordine.tot_trasp * 0.1;
      } else {
        return 0;
      }
    },
    stato_consegna(sub) {
      if (sub.consegna_programmata) {
        if (sub.consegnato) {
          return { text: "Consegnato", color: "green", mdi: "mdi-truck" };
        } else if (!sub.consegnato && sub.in_consegna) {
          return {
            text: "In Consegna",
            color: "blue",
            mdi: "mdi-truck-fast",
          };
        } else {
          return {
            text: "Pianificata",
            color: "purple",
            mdi: "mdi-truck-check",
          };
        }
      } else {
        return {
          text: "Da Consegnare",
          color: "grey",
          mdi: "mdi-truck-delivery",
        };
      }
    },
  },
};
</script>
